
export let invoiceMailContent = `Dear [Customer Name],

We hope this email finds you well.

Please find attached your invoice for the recent transaction with us. The details of the invoice are as follows:
Invoice Number: [Invoice Number]
Invoice Date: [Invoice Date]
Due Date: [Due Date]
Total Amount: [Amount]

We kindly request you to review the attached invoice and settle the payment by the due date to ensure uninterrupted services. You can make your payment via [Payment Method] provided in the invoice.

Important Notes:
Please reach out to us if any discrepancies are found or if further clarification is needed.
In case the payment has already been made, please disregard this message.
Invoice Attachment: Please find your invoice attached in PDF format for easy reference.

This is an automated email. Please don't reply to this mail , contact [Company Email] or [Company Phone No].

Thank you for your prompt attention to this matter. We appreciate your continued business with us.

Best regards,
[Your Name]
[Your Position]
[Company Name]
[Email Address] | [Phone Number]
[Website URL]`;

export let reminderMailContent = `Dear [Customer Name],

I hope you are doing well.

This is a friendly reminder that your payment for Invoice [Invoice Number], dated [Invoice Date], is due on [Due Date]. The outstanding balance is [Amount].
We kindly request that you arrange payment at your earliest convenience to avoid any disruptions in our services. For your reference, here are the key details:
Invoice Number: [Invoice Number]
Invoice Date: [Invoice Date]
Amount Due: [Amount]
Due Date: [Due Date]

You can make your payment via [Payment Method(s)] provided in the invoice. If you've already processed the payment, please disregard this message and accept our thanks.

In case of any issues or questions regarding the invoice, feel free to contact us at [Company Email] or [Company Phone No].

Thank you for your prompt attention to this matter.

Best regards,
[Your Name]
[Your Position]
Company Name
[Email Address] | [Phone Number]
`;
export let paymentConformation = `Dear [Customer Name],
Hello,
Please find the attached PDF containing details of the payment made via Bank/Cash.
Kindly confirm receipt of the amount by replying to this email at [Company Email] or contacting us at [Company Phone No].
Thank you for your attention.
Warm regards,
Mr./Mrs. [Your Name]
Accountant

`;

export let debitNoteMailContent = `Dear [partyName],

Please find the attached Debit Note [debitNoteNumber] dated [debitNoteDate] for an amount of ₹[amount] issued against your account.

This document has been generated from our accounting system for your reference and records. Kindly review the details and let us know if you have any queries.

Best regards,
[companyName]
[companyEmail] | [companyPhone]`;

export let creditNoteMailContent = `Dear [partyName],

Please find the attached Credit Note [creditNoteNumber] dated [creditNoteDate] for an amount of ₹[amount] issued in your favor.

This document has been generated from our accounting system for your reference and records. Kindly review the details and let us know if you have any queries.

Best regards,
[companyName]
[companyEmail] | [companyPhone]`;

export let transactionSummaryMailContent = `Dear [Customer Name],

We hope this email finds you well.

Please find attached your transaction statement for [Date From]–[Date To].
Outstanding balance as of [As of Date]: [Currency] [Outstanding Amount].
If you have already settled this amount, please ignore this reminder.

Notes:
If you notice any discrepancies, please contact us at [Company Email] or [Company Phone No].
Statement attached in PDF format for your reference: Statement_[Date From]_[Date To].pdf
This is an automated email. Please do not reply to this email; contact [Company Email] or [Company Phone No].

Thank you for your continued business.

Best regards,
[Your Name]
[Your Position]
[Company Name]
[Email Address] | [Phone Number]
[Website URL]`;

export let purchaseMailContent = `Dear [Supplier Name],

We hope this email finds you well.

Please find attached your purchase order/invoice for the recent transaction with us. The details of the purchase are as follows:
Purchase Order Number: [Purchase Order Number]
Purchase Date: [Purchase Date]
Due Date: [Due Date]
Total Amount: [Amount]

We kindly request you to review the attached document and process the order as per the agreed terms. The payment will be processed according to our payment terms.

Important Notes:
Please reach out to us if any discrepancies are found or if further clarification is needed.
In case the order has already been processed, please disregard this message.
Purchase document attached in PDF format for easy reference.

This is an automated email. Please don't reply to this mail, contact [Company Email] or [Company Phone No].

Thank you for your prompt attention to this matter. We appreciate your continued business with us.

Best regards,
[Your Name]
[Your Position]
[Company Name]
[Email Address] | [Phone Number]
[Website URL]`;




export const emailProviders = [
  { label: "smtp.gmail.com", tlsPort: 587, sslPort: 465 },
  { label: "smtp.office365.com", tlsPort: 587, sslPort: 465 },
  { label: "smtp.mail.yahoo.com", tlsPort: 587, sslPort: 465 },
  { label: "smtp.mail.me.com", tlsPort: 587, sslPort: 465 },
  { label: "smtp.zoho.com", tlsPort: 587, sslPort: 465 },
  { label: "smtp.sendgrid.net", tlsPort: 587, sslPort: 465 },
  { label: "smtpout.secureserver.net", tlsPort: 587, sslPort: 465 },
];

export const initial = {
  email: "",
  templateid: "",
  emailbody: "",
  smtp_hostname: "",
  smtp_ports: [],
  smtp_port: "",
  username: "",
  password: "",
  savedPassword: "",
  newPassword: false,
  isUserName: false,
  errorStatus: {
    email: false,
    templateid: false,
    emailbody: false,
    smtp_hostname: false,
    smtp_port: false,
    username: false,
    password: false,
  },
  errorFields: {
    email: "",
    templateid: "",
    emailbody: "",
    smtp_hostname: "",
    smtp_port: "",
    username: "",
    password: "",
  },
};